import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	copyButton: {
		height: "100%",
		width: "100%",
		fontSize: "14px",
		lineHeight: "24px",
		marginLeft: "-3px"
	}
})

export default useStyles
